import { TranscriptsApiService, } from '@corti/lib/transcriptsApiService';
export let api = null;
export function initTranscriptsApiService(config) {
    api = new TranscriptsApiService(config);
}
export * from './utils';
